import React from "react";
import POSelection from "../PoReconcile/POSelection";
import { Box, Button } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import AddMrvModal from "./AddMrvModal";
import PoDetails from "./PoDetails";

import { taggedMrqMaterialsCols } from "../Components/cols/mrqMaterialsCols";
import { mrqMaterialsMcsDataCols } from "../Components/cols/mrqMaterialsMcsCols";
import { useMcsContext } from "../MCS.context";
import { lightTable } from "../../../../../../styles/muiProps";
import LabelledBox from "../../../../../../components/widgets/LabelledBox";
import DescriptionIcon from "@mui/icons-material/Description";

export default function PoManger() {
  const { project } = useMcsContext();

  const [openAddMrvModal, setOpenAddMrvModal] = React.useState(false);
  const [selectedPoMaterials, setSelectedPoMaterials] = React.useState([]);
  const [selectedDrawingMaterials, setSelectedDrawingMaterials] =
    React.useState([]);

  const formattedData = (materials) => {
    // console.log({ materials });
    return materials?.map((pm) => {
      return {
        materials: pm.mrqMaterial.materials,
        costCode: pm.mrqMaterial?.materials?.[0]?.costCode,
        description: pm.mrqMaterial?.description,
        quantity: pm.mrqMaterial?.quantity,
        unit: pm.mrqMaterial?.unit,
        mrvQuantity: pm.mrqMaterial?.quantity,
        mrvMrqMaterials: pm.mrqMaterial?.mrvMrqMaterials,
        heatNumber: pm.mrqMaterial?.heatNumber,
        remarks: pm.mrqMaterial?.remarks,

        id: [pm.mrqMaterial?.id],
      };
    });
  };

  const table = useMaterialReactTable({
    data: formattedData(project.selectedPo?.poMaterials) || [],
    columns: [
      ...taggedMrqMaterialsCols,
      // {
      //   accessorKey: "status",
      //   header: "Status",
      //   grow: false, //don't allow this column to grow to fill in remaining space
      //   size: 60,
      //   Cell: (row) => {
      //     const list = [
      //       { state: "Accepted", color: "green" },

      //       { state: "Delivered", color: "blue" },

      //       { state: "Rejected", color: "red" },

      //       { state: "Pending", color: "black" },

      //       { state: "shipped", color: "green" },
      //     ];

      //     const randomIndex = Math.floor(Math.random() * list.length);
      //     const randomItem = list[randomIndex];
      //     return <Box sx={{ color: randomItem.color }}>{randomItem.state}</Box>;
      //   },
      // },
      {
        accessorKey: "doc",
        header: "Doc",
        grow: false, //don't allow this column to grow to fill in remaining space
        size: 60,
        Cell: ({ row }) => {
          // console.log({ row: row.original });
          return (
            <Box sx={{ textAlign: "center" }}>
              {row.original.heatNumber && (
                <DescriptionIcon sx={{ color: "#444" }} />
              )}
            </Box>
          );
        },
      },
      ...mrqMaterialsMcsDataCols.filter(
        (c) => !["mrqNumber", "poNumber", "srvNumber"].includes(c.accessorKey)
      ),
    ],
    ...lightTable,
    enableTopToolbar: true, //overriding lightTable

    enableRowSelection: true,

    renderTopToolbarCustomActions: ({ table }) => {
      const selectedRows = table.getSelectedRowModel();

      const isDisabled = () => {
        if (selectedRows?.rows[0]) {
          return false;
        }
        return true;
      };

      const onAddToMrv = () => {
        console.log({ selectedRows });
        setSelectedDrawingMaterials([]);
        setOpenAddMrvModal(true);
        setSelectedPoMaterials(
          selectedRows.rows.map((r) => {
            return { ...r.original, id: r.original.id[0] };
          })
        );
      };
      return (
        <Box sx={{ display: "flex", gap: "1rem", p: "4px" }}>
          <AddMrvModal
            openAddMrvModal={openAddMrvModal}
            setOpenAddMrvModal={setOpenAddMrvModal}
            selectedPoMaterials={selectedPoMaterials}
            setSelectedPoMaterials={setSelectedPoMaterials}
            selectedDrawingMaterials={selectedDrawingMaterials}
            setSelectedDrawingMaterials={setSelectedDrawingMaterials}
          />
          <Button
            variant="contained"
            disabled={isDisabled()}
            onClick={onAddToMrv}
          >
            Add to MRV
          </Button>
        </Box>
      );
    },
  });
  return (
    <Box sx={{ ml: 3 }}>
      <Box>
        <LabelledBox label="PO Manager :">
          {/* sx={{ display: 'inline-block' }}> */}
          <POSelection from="poManager" />
        </LabelledBox>

        {project.selectedPo?.id && <PoDetails po={project.selectedPo} />}
      </Box>

      <MaterialReactTable table={table} />
    </Box>
  );
}
